import React from 'react';

import ProductJsonld from './product-json-ld';
import useDeviceInfo from '../../hooks/useDeviceInfo';
import useProductPrice from '../../hooks/useProductPrice';

/**
 * Wrapper component that renders children with ProductJsonLd
 * @param {React.ReactNode} children - Child components to render
 * @param {Object} product - Product data
 */
export const ProductJsonLdWrapper = ({ children, product }) => {
    const { isBot } = useDeviceInfo(['isBot']);
    const { prices } = useProductPrice([product]);
    const price = (prices || {})[product?.sku];

    return (
        <>
            {children}
            {product && <ProductJsonld product={{ ...product }} price={price} enableImageDetails={isBot} />}
        </>
    );
};

export default ProductJsonLdWrapper;
